'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_ITEMS = exports.SET_ITEMS = 'yourchoice-redux/SET_ITEMS';
var SET_SELECTION = exports.SET_SELECTION = 'yourchoice-redux/SET_SELECTION';
var RANGE_TO = exports.RANGE_TO = 'yourchoice-redux/RANGE_TO';
var REMOVE = exports.REMOVE = 'yourchoice-redux/REMOVE';
var REMOVE_ALL = exports.REMOVE_ALL = 'yourchoice-redux/REMOVE_ALL';
var REPLACE = exports.REPLACE = 'yourchoice-redux/REPLACE';
var TOGGLE = exports.TOGGLE = 'yourchoice-redux/TOGGLE';


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/actionTypes.js
// module id = 1
// module chunks = 0